import { CountryCode } from 'chaika-enums';

export const PhoneCountryCode = {
    [CountryCode.Ru]: '7',
    [CountryCode.Am]: '374',
    [CountryCode.Ge]: '995',
    [CountryCode.Ae]: '9715',
    [CountryCode.Pt]: '351',
    [CountryCode.Gb]: '44',
};
